import { ID } from '@griply/types';

type MinimalItem = {
  id: ID;
};

// The optimistic post-drop order applies only while it is a pending reorder of
// the same items (same membership, different order). Once the persisted write
// round-trips (source reaches the override order) or the item set itself
// changes, the source order wins — so a list never flashes back to the pre-drag
// order mid-write, and never hides a newly added/removed item.
export const resolveOptimisticOrder = <Item extends MinimalItem>(
  sourceItems: Item[],
  override: Item[] | undefined,
): Item[] => {
  if (!override || override.length !== sourceItems.length) {
    return sourceItems;
  }

  const overrideIds = new Set(override.map(({ id }) => id));
  const sameMembership = sourceItems.every(({ id }) => overrideIds.has(id));
  const sameOrder = sourceItems.every(
    (item, index) => item.id === override[index].id,
  );

  if (!sameMembership || sameOrder) {
    return sourceItems;
  }

  return override;
};
